import React from 'react';
import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/system';

const SectionWrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
  textAlign: 'justify'
}));

const InfoTextWrapper = styled('div')(({ theme }) => ({
  textAlign: 'left',
  padding: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

const ImageWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: '600px',
  margin: '0 auto',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const ImageMobileWrapper = styled('div')(({ theme }) => ({
   width: '50%',
   margin: '0 auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
  },
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

const Image = styled('img')(({ theme }) => ({
  width: '100%',
  height: 'auto',
  borderRadius: '8px',
}));

const Title = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

const ContentDiv = styled('div')({
  textAlign: 'justify',
});

const ContentSection = ({ contentSections, mainImageSrc }) => (
  <SectionWrapper>
    <Grid container spacing={4}>
      <Grid item xs={12} md={6}>
        <InfoTextWrapper>
            <Title variant="h4">
                   {contentSections.title}
                 </Title>
          <ImageMobileWrapper>
            <Image src={mainImageSrc} />
          </ImageMobileWrapper>
          {contentSections.sections.map((section, index) => (
           <ContentDiv key={index}>
                       <Typography variant="h5">{section.label}</Typography>
                       <Typography variant="body2">{section.value}</Typography>
           </ContentDiv>
          ))}
        </InfoTextWrapper>
      </Grid>
      <Grid item xs={12} md={6}>
        <ImageWrapper>
          <Image src={mainImageSrc} />
        </ImageWrapper>
      </Grid>
    </Grid>
  </SectionWrapper>
);

export default ContentSection;